import { render, staticRenderFns } from "./BottomNavigation.vue?vue&type=template&id=4f161964&scoped=true&"
import script from "./BottomNavigation.vue?vue&type=script&lang=ts&"
export * from "./BottomNavigation.vue?vue&type=script&lang=ts&"
import style0 from "./BottomNavigation.vue?vue&type=style&index=0&id=4f161964&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f161964",
  null
  
)

export default component.exports